export var INIT = 0;
export var FAIL = 9;
export var CONTACT = 14;
export var COURIER_UNKNOWN = 15;
export var CANCELED = 16;
export var NECESSARY_ACTION = 6;
export var REFUSE_RETENTION = 28;